import api from './api';

export interface ContabilidadRptRow {
  fechaAsiento?: string | null;
  nroAsiento?: number | null;
  lidiAclaracion?: string | null;
  contabilizado?: string | null;
  impNroCuenta?: number | null;
  detalle?: string | null;
  debe?: number | null;
  haber?: number | null;
  saldo?: number | null;
  descripcionCta?: string | null;
  nroRubro?: number | null;
  nomCuenta?: string | null;
  tipoCuentaImputa?: string | null;
  visibleEn?: string | null;
  nombreCuenta?: string | null;
  descripcion?: string | null;
  nroFormulario?: number | null;
  nroTipoFormulario?: string | null;
  letra?: string | null;
  nroSuc?: number | null;
  nroComprobante?: number | null;
  fechaEmision?: string | null;
  nroCliente?: number | null;
  nombre?: string | null;
  cuit?: string | null;
  subtotal?: number | null;
  importeSinIva?: number | null;
  importeTotal?: number | null;
  formaDePago?: string | null;
  asentado?: string | null;
  usuario?: string | null;
}

export interface ContabilidadRptResponse {
  data: ContabilidadRptRow[];
  totalMatched: number;
  truncated: boolean;
}

export interface GetRptContabilidadParams {
  fechaDesde: string;
  fechaHasta: string;
  nroCliente?: number;
  nroCuenta?: number | number[];
  nroTipoFormulario?: string;
  nroSuc?: number;
  maxRows?: number;
}

const contabilidadInformesService = {
  getRptContabilidad: async (params: GetRptContabilidadParams): Promise<ContabilidadRptResponse> => {
    const query = new URLSearchParams();
    query.append('fechaDesde', params.fechaDesde);
    query.append('fechaHasta', params.fechaHasta);
    if (params.nroCliente != null) query.append('nroCliente', String(params.nroCliente));
    const cuentas = params.nroCuenta == null
      ? []
      : (Array.isArray(params.nroCuenta) ? params.nroCuenta : [params.nroCuenta]);
    cuentas.forEach((cuenta) => query.append('nroCuenta', String(cuenta)));
    if (params.nroTipoFormulario?.trim()) query.append('nroTipoFormulario', params.nroTipoFormulario.trim());
    if (params.nroSuc != null) query.append('nroSuc', String(params.nroSuc));
    if (params.maxRows != null) query.append('maxRows', String(params.maxRows));

    const response = await api.get<ContabilidadRptResponse>(
      `/api/ContabilidadInformes/rpt-contabilidad?${query.toString()}`,
    );
    return response.data;
  },
};

export default contabilidadInformesService;
